import { combineEpics } from "redux-observable";
import { from } from "rxjs";
import {
    catchError,
    debounceTime,
    delay,
    filter,
    groupBy,
    map,
    merge,
    mergeMap,
} from "rxjs/operators";

import { actionCreators, isOfAction } from "../actions";
import { getTypingButLog } from "../reducers/debugLog";
import { getTypingByRoomId } from "../reducers/joinedRooms";
import { checkUsersHaveName } from "../reducers/roster";
import { notUndefined } from "../utils/any";
import { Epic } from "../utils/types";

// If any user_ids are not in our user_roster, we don't have them in our roster and won't be able to display their names as "typing..." -- fetch them and add to roster
// FIXME: don't actually display them in the roster / need a way to filter out anything that is not in user_roster on the client.
const onTyping: Epic = (action$, state$) =>
    action$.pipe(
        filter(isOfAction(actionCreators.onTyping)),
        map(({ payload: { user_ids: userIds } }) => checkUsersHaveName(state$.value, userIds)),
        filter(userIds => userIds.length > 0),
        map(userIds =>
            actionCreators.ensureUsersLoadedRequested({ userIds, tag: "[typing_user_ids]" })
        )
    );

const onTypingStuck: Epic = (action$, state$) =>
    action$.pipe(
        filter(isOfAction(actionCreators.onTyping)),
        map(({ payload: { room_id: id } }) => id),
        merge(
            action$.pipe(
                filter(isOfAction(actionCreators.checkIfTypingStuck)),
                map(({ payload: { roomId } }) => roomId)
            )
        ),
        groupBy(roomId => roomId),
        mergeMap(grouped$ => {
            const roomId = grouped$.key;
            return grouped$.pipe(
                // there was no activity in this room for 1 minute, we expect it not to have "typing" indicator
                debounceTime(60 * 1000),
                delay(1000), // otherwise we can't react later to our CHECK_IF_TYPING_STUCK
                map(() => getTypingByRoomId(state$.value).get(roomId)),
                filter(notUndefined),
                map(() => actionCreators.checkIfTypingStuck({ roomId }))
            );
        })
    );

const onCheckIfTypingStuck: Epic = (action$, state$, { App }) =>
    action$.pipe(
        filter(isOfAction(actionCreators.checkIfTypingStuck)),
        mergeMap(({ payload: { roomId } }) =>
            from(App.proto.getTyping(roomId, { tag: "[check_typing]" })).pipe(
                map(data => {
                    if (data.user_ids.length === 0) {
                        setTimeout(() => {
                            // tslint:disable-next-line:no-console
                            console.log(roomId);
                            // tslint:disable-next-line:no-console
                            console.log(getTypingButLog(state$.value, roomId));
                            console.error("typing indicator stuck");
                        });
                    }
                    return actionCreators.onTyping(data);
                }),
                // it's ok to get error for this request
                // CHECK_IF_TYPING_STUCK will run again later if it will continue to be stuck
                catchError(() => [])
            )
        )
    );

export const typingIndicatorsEpic = combineEpics(onTyping, onTypingStuck, onCheckIfTypingStuck);
